// extracted by mini-css-extract-plugin
export default {"scroller_item":"index-module__scroller_item--vcowy","cards_grid":"index-module__cards_grid--f5HPI","grid":"index-module__grid--SVuAb"};